import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("bp-cite")
export class Cite extends LitElement {
  static styles = css`
    cite {
      color: var(--bp-cite-color, var(--color-gray));
      font-size: inherit;
    }

    a {
      color: inherit;
      text-decoration: underline;
    }
  `;

  @property()
  href?: string;

  handleClick(e: MouseEvent) {
    if (globalThis.window.BibleProjectApp) e.preventDefault();

    document.dispatchEvent(
      new CustomEvent("bp:external_link", {
        detail: { href: this.href },
      }),
    );
  }

  render() {
    const children = this.href
      ? html`
          <a href="${this.href}" target="_blank" @click="${this.handleClick}">
            <slot></slot>
          </a>
        `
      : html`<slot></slot>`;

    return html`<cite>${children}</cite>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-cite": Cite;
  }
}
